import {NoJobSaved} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Box, Typography} from '@mui/material';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {openUrl} from '@jobseeker/common-core/utils/common';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const NoAppliedJobs = () => {
  return (
    <Box
      height={'80vh'}
      display={{xxs: 'block', md: 'flex'}}
      justifyContent={'center'}
      alignItems={'center'}
      marginTop={{xxs: 7, md: 0}}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        px={{xxs: 2, md: 3}}
      >
        <Image
          src={
            isAppIimjobs
              ? NoJobSaved
              : 'https://job-static.hirist.com/V8/static/media/no-jobfeed.7771e408.svg'
          }
          alt={'NoJobSaved'}
          width={179}
          height={179}
          object-fit="contain"
        />
        <Typography
          fontSize={18}
          color="secondary.dark"
          variant="subtitle1"
          ml={0.625}
          sx={{
            lineHeight: '30px',
          }}
        >
          {'No Applied Jobs!'}&nbsp;
        </Typography>

        <Typography
          component={'h1'}
          fontSize={12}
          fontWeight={500}
          display="flex"
          color="text.secondary"
        >
          You have not applied to any jobs yet. Once you apply,
        </Typography>
        <Typography
          component={'h1'}
          fontSize={12}
          fontWeight={500}
          display="flex"
          color="text.secondary"
        >
          they'll appear here.
        </Typography>

        <Button
          sx={{
            background: '#000',
            mt: {xxs: 1, md: 2},
            px: 2,
            py: 1,
            height: 'fit-content',
            backgroundColor: 'secondary.main',
          }}
          variant="contained"
          size="16px"
          onClick={() => {
            openUrl('/jobfeed', '_self');
          }}
        >
          {'Go to Jobfeed'}
        </Button>
      </Box>
    </Box>
  );
};

export default NoAppliedJobs;
